<template>
  <div class="add-black-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="600px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="params" :rules="rules" label-width="120px">

        
         <el-form-item label="请选择类型:" prop="type">
          <el-select v-model="params.type" size="small" placeholder="请选择类型">
            <el-option v-for="item in blackType" :value="item.value" :label="item.label" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="输入内容:" prop="content">
          <el-input type="textarea"  :rows="3" placeholder="请输入内容" v-model="params.content" size="small"></el-input>
        </el-form-item>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'

export default {
  data() {
    return {
      dialogVisible: false,
      title: '',
      flag: false,
    // 黑名单类型
     blackType: [{
        label: 'IP',
        value: 'IP'
      }],
      // 请求参数
      params: {
        type: '',
        content: '',
      },
      // 表单验证规则
      rules: {
        type: [
          { required: true, message: '请选择黑名单类型', trigger: 'change' },
        ],
        content: [{ required: true, message: '请输入内容', trigger: 'blur' }]
      }
    }
  },
  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true
          if (this.title === '新增黑名单') {
            this.addBlack()
          } 
        } else {
          return false;
        }
      });
    },
    addCity() {
      return
    },
    // 编辑标签
    addBlack() {
      API.addBlackList(this.params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '添加成功',
            type: 'success'
          });
          this.$emit('handlerAddblack')
        } else {
          this.$message.error('编辑失败');
        }
        this.handleClose();
        this.flag = false
      }).catch(() => {
        this.handleClose();
        this.flag = false
      })
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        type: '',
        content: ''
      }
      this.$refs.form.resetFields()
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type) {

      this.dialogVisible = true
      if (type === 'add') {
        this.title = '新增黑名单'
      } 
    }
  }

}
</script>

<style lang="scss" >

</style>
